import styled from "styled-components";
import { usePageTitle } from "../Util/title";
import {AccountBannedPage} from "./FC/bans/AccountBanned";

const ErrorPageWrapper = styled.div`
  padding: 10px 20px 10px 20px;
  font-weight: 600;

  h1 {
    font-size: 30px;
  }
`;

const ErrorPage = ({ children, title }) => {
  usePageTitle(title);
  return <ErrorPageWrapper>{children}</ErrorPageWrapper>;
};

const E401 = () => {
  return (
    <ErrorPage title="Login Required">
      <p>
        You must login to view this page.
      </p>
      <p>
        If you attempted to log in and ended up back here, it means you need to log in with your main character first.
      </p>
      <p>
        If problems persist, please contact an EVE Rookies team member.
      </p>
    </ErrorPage>
  );
};

const E403 = () => {
  return (
    <ErrorPage title="Forbidden">
      <h1>403 Error</h1>
      You are not allowed to view this page. Contact leadership to request access.
    </ErrorPage>
  );
};

const E403Banned = ({ban}) => {
    return (
        <ErrorPage title="Forbidden">
            <AccountBannedPage ban={ban} />
        </ErrorPage>
    )
}

const E404 = () => {
  return (
    <ErrorPage title="Page Not Found">
      <h1>404 Error</h1>I warped to the FC twice, and all I got was this &ldquo;404: page not
      found&rdquo; error.
    </ErrorPage>
  );
};

const E502 = () => {
  return (
    <ErrorPage title="Could not reach server">
      <h1>502 Error</h1>The waitlist cannot currently reach the backend server. Please try again shortly.
    </ErrorPage>
  );
};


export { E401, E403, E404, E403Banned, E502 };
